import { cn } from "@/lib/utils";
import { type ReactNode } from "react";

type FieldLabelProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Uppercase, tracking-wide muted label used consistently across company
 * cards (identity fields, web-traffic rows, section headings).
 */
export default function FieldLabel({ children, className }: FieldLabelProps) {
  return (
    <span
      className={cn(
        "text-xs text-muted-foreground uppercase tracking-wide",
        className,
      )}
    >
      {children}
    </span>
  );
}
